let RightsConstant = /** @class */ (() => {
    class RightsConstant {
    }
    RightsConstant.Dashboard = class {
        static BasicPrivilege() {
            return "a9657516-c468-4949-ac06-3e00f3920776";
        }
    };
    // static Bulkselection = class {
    //     static BasicPrivilege(): string {
    //         return "27abcf23-fd1b-4d5c-b768-ddfbb80f53a0";
    //     }
    // };
    RightsConstant.Employees = class {
        static CanView() {
            return "e21d1429-10bd-4fec-8bdf-049f49228342";
        }
        static CanEdit() {
            return "58fad25a-77b8-4f2f-853a-484aeacba03c";
        }
        static CanAdd() {
            return "48206897-0da4-43a7-8af8-a8798aba9ae6";
        }
        static BasicPrivilege() {
            return "6f6b3cf2-04c0-49ac-9ab2-63260916b7b6";
        }
    };
    RightsConstant.Users = class {
        static BasicPrivilege() {
            return "c9ca3626-27e2-445e-bae7-041276c3fb6e";
        }
    };
    RightsConstant.ListManager = class {
        static BasicPrivilege() {
            return "4b750ee6-cd20-4776-bad0-c225a5f18419";
        }
    };
    RightsConstant.PageManager = class {
        static BasicRoot() {
            return "1d770ee7-7af7-4a61-b7b2-7de1d51fe291";
        }
    };
    RightsConstant.MenuManager = class {
        static BasicPrivilege() {
            return "9eb7217b-2dcb-4b07-86b3-35cac91df9c8";
        }
    };
    RightsConstant.ScriptManager = class {
        static BasicPrivilege() {
            return "a651fbb2-76f6-4117-b469-a63c49cb5d6b";
        }
    };
    RightsConstant.RoleManager = class {
        static BasicPrivilege() {
            return "2cc2acf4-70eb-45b1-a785-82aa29cd9433";
        }
    };
    RightsConstant.Teams = class {
        static BasicPrivilege() {
            return "e0ff846d-59d7-4748-88f1-a4386ff22685";
        }
    };
    RightsConstant.Products = class {
        static BasicPrivilege() {
            return "dcf110ea-8a5f-4258-a1fc-494ed17274e0";
        }
    };
    RightsConstant.Services = class {
        static BasicPrivilege() {
            return "bf335186-40cb-421c-9f7e-12d52f98765f";
        }
    };
    RightsConstant.Clockwork = class {
        static BasicPrivilege() {
            return "062a4486-6f62-4a55-b783-b0434e3b5489";
        }
        static CentralizedClockwork() {
            return "be48c1e2-7427-433f-8211-995e1c90f3d6";
        }
    };
    RightsConstant.PrayTube = class {
        static BasicPrivilege() {
            return "4fe5a3bd-fe21-4a09-ae8c-f4003dde1e16";
        }
    };
    RightsConstant.DragDrop = class {
        static BasicPrivilege() {
            return "c35d4673-2c7a-4526-9d4e-b811be6c1f6a";
        }
    };
    RightsConstant.DndShipper = class {
        static BasicPrivilege() {
            return "132d1a11-ff5e-4291-a6cb-d7bf8194a72c";
        }
    };
    RightsConstant.ImageCropper = class {
        static BasicPrivilege() {
            return "cec2ffa7-80df-46b8-b2bf-be1cb2d29d25";
        }
    };
    RightsConstant.UIElements = class {
        static BasicPrivilege() {
            return "eb42a97f-c5d5-4a6a-b72c-bf375ac13940";
        }
    };
    RightsConstant.AssetMaster = class {
        static BasicPrivilege() {
            return "3daa7402-0418-4fe4-87f8-28482672a1c2";
        }
        static CanAdd() {
            return "3d955aac-bd77-4ce6-b35a-63753f8b03ff";
        }
        static CanDelete() {
            return "1dc07ec3-c085-4665-8205-54c58ca53a4f";
        }
        static CanEdit() {
            return "d1ddf234-710e-4a0c-a1c6-c81ca2b93bdc";
        }
    };
    RightsConstant.AssetManager = class {
        static CanView() {
            return "3ae1d2e6-e686-4022-85fd-5288071cf40b";
        }
        static CanDelete() {
            return "4492a3ed-271e-4502-9cd3-9fe14109b898";
        }
        static CanEditAssetTypeProperties() {
            return "c33c9386-76cd-432d-9990-86fae71a10e1";
        }
        static BasicPrivilege() {
            return "4d7908a0-3c23-4a64-9a48-a8ac1fc4908e";
        }
        static CanEditAssetDetails() {
            return "7995dd22-5660-4748-b927-e83ec84171b4";
        }
        static CanAdd() {
            return "c47e9d63-ab42-453b-8ee1-f0c8cd8447d6";
        }
        static CanAssignAsset() {
            return "10e7ce47-f4df-4260-a43d-d97cbedace0d";
        }
    };
    RightsConstant.AssetAssignments = class {
        static BasicPrivilege() {
            return "8bcecdf9-099b-4bd0-84c4-390281c2dec6";
        }
    };
    RightsConstant.Projects = class {
        static BasicPrivilege() {
            return "d66e7f1b-99d8-4058-b3d4-73ece06b0afc";
        }
    };
    RightsConstant.Tools = class {
        static BasicPrivilege() {
            return "6880e3b3-8098-4cff-823f-728a1cdbbbb4";
        }
    };
    RightsConstant.Uszipcode = class {
        static BasicPrivilege() {
            return "3921e38c-8874-4176-8cb8-cdf4dea00775";
        }
    };
    RightsConstant.Workview = class {
        static BasicPrivilege() {
            return "fddf2e21-c694-42fb-a195-2232d693060d";
        }
    };
    RightsConstant.Assetdetailed = class {
        static BasicPrivilege() {
            return "42f8751e-4b3c-4e18-847c-5f5774c81180";
        }
    };
    RightsConstant.Vendors = class {
        static BasicPrivilege() {
            return "685456cc-fdf2-485a-b7f0-10bb03ee6fce";
        }
    };
    RightsConstant.AssetSummary = class {
        static BasicPrivilege() {
            return "a40b6543-6fb9-43bf-ab0b-37a406526b79";
        }
    };
    RightsConstant.AssetCullOutReport = class {
        static BasicPrivilege() {
            return "add71962-06c3-482a-9f21-3afa2ef8bb4a";
        }
    };
    RightsConstant.AssetStatusReport = class {
        static BasicPrivilege() {
            return "856ca42a-abff-486a-94b1-f2e589d8eaec";
        }
    };
    RightsConstant.UserLogins = class {
        static BasicUserPrivilege() {
            return "44d60d4c-51ad-453f-8772-04c65d2439e5";
        }
    };
    RightsConstant.Engagements = class {
        static BasicPrivilege() {
            return "6db7b08d-0ba3-4d8c-b11e-7442d93afb2b";
        }
    };
    RightsConstant.Workflow = class {
        static BasicPrivilege() {
            return "7f9ce4d1-3ed7-496b-ba41-bd7e889505d0";
        }
    };
    RightsConstant.Forms = class {
        static BasicPrivilege() {
            return "5dd782c2-b9df-4f11-bc18-d510cfea546e";
        }
    };
    RightsConstant.Notification = class {
        static BasicPrivilege() {
            return "1c7e2222-ac00-4edd-beca-cd705204d93b";
        }
    };
    RightsConstant.Cycle = class {
        static BasicPrivilege() {
            return "ef31c992-d686-4927-9c15-2031a1d31bf4";
        }
        static CanManageReviewMeeting() {
            return "0909bfe1-7079-4544-bc99-624f25f1f4b6";
        }
        static CanAdd() {
            return "18632135-d655-4047-a1b4-b44fd1ddd592";
        }
    };
    RightsConstant.Reviews = class {
        static BasicPrivilege() {
            return "5e151d28-6ad8-4283-bf8c-07129eef48a5";
        }
        static CanViewNudgeHistory() {
            return "b1620ae6-2248-4d77-9c48-de6760d7c809";
        }
    };
    RightsConstant.Clients = class {
        static BasicPrivilege() {
            return "6bcec50e-71b9-4286-ac33-8cf4f8e90d10";
        }
    };
    RightsConstant.Steps = class {
        static BasicPrivilege() {
            return "11289c99-0331-43c2-b9df-62bf50dba4fb";
        }
    };
    RightsConstant.Designation = class {
        static BasicPrivilege() {
            return "ef73574b-b9bd-4cb3-a946-984abb238b3a";
        }
    };
    RightsConstant.Timereport = class {
        static BasicPrivilege() {
            return "8936577b-02c9-4493-ae7b-1b6810ecaa4a";
        }
    };
    RightsConstant.Archives = class {
        static BasicPrivilege() {
            return "830d892a-4d0d-49fe-bf99-1849684240e8";
        }
        static CanViewAllReviews() {
            return "d284a05e-06c0-4513-8ffd-d908769de102";
        }
    };
    RightsConstant.ProjectAnalytics = class {
        static BasicPrivilege() {
            return "b7cf5466-45f6-4f42-a96d-066b91858f62";
        }
    };
    RightsConstant.CalendarEvents = class {
        static BasicPrivilege() {
            return "5988a44b-a00c-44cb-a930-c5aa54016e8b";
        }
    };
    RightsConstant.Entries = class {
        static BasicPrivilege() {
            return "63c5ea55-6a6c-4e14-8e58-84f40ef72d0c";
        }
    };
    RightsConstant.ClockworkAnalytics = class {
        static BasicPrivilege() {
            return "faef4251-171f-4bf7-94dc-211f551cc2fa";
        }
    };
    RightsConstant.Calendar = class {
        static BasicPrivilege() {
            return "db22e27b-3975-4335-9808-14b4360d8ed7";
        }
    };
    RightsConstant.Multiselect = class {
        static BasicPrivilege() {
            return "3748ad6f-619e-4a77-8668-92cc5b392b72";
        }
    };
    RightsConstant.VueGridLayout = class {
        static BasicPrivilege() {
            return "5bc65c27-1cb4-424e-ba4f-6b59d5651a23";
        }
    };
    RightsConstant.TreeView = class {
        static BasicPrivilege() {
            return "3b41f059-d4ee-4c86-bf53-761e1d1ed96f";
        }
    };
    RightsConstant.OrganizationSettings = class {
        static BasicPrivilege() {
            return "88bace6c-7333-4d84-ac9a-1609dece2f42";
        }
    };
    RightsConstant.OpenAI = class {
        static BasicPrivilege() {
            return "c6ee4459-7403-49bc-892c-e8f3691fb86b";
        }
    };
    RightsConstant.AssetDepreciation = class {
        static BasicPrivilege() {
            return "be1c3d3e-83d3-486c-8aa5-51eec2487370";
        }
    };
    RightsConstant.Tags = class {
        static BasicPrivilege() {
            return "c2a9e779-0388-463e-8705-4606bef2b1be";
        }
    };
    RightsConstant.ProjectTags = class {
        static BasicPrivilege() { return "9BEF0D2D-944A-4E04-8E8F-438E09817E8B"; }
        ;
    };
    RightsConstant.Holidays = class {
        static BasicPrivilege() {
            return "47843dec-9ca7-46e7-a878-6e2c8574151a";
        }
    };
    RightsConstant.PermeaSettings = class {
        static BasicPrivilege() {
            return "94ce2100-4c5b-4ac3-8cf1-ac9bd9af9c14";
        }
    };
    RightsConstant.TagReport = class {
        static BasicPrivilege() {
            return "7a5ca812-ed0f-429f-9a8c-a1d4c15cd978";
        }
    };
    return RightsConstant;
})();
export { RightsConstant };
